export enum TipoReporteGlosa{

    REPORTE_GENERAL = 1,
    REPORTE_DETALLE = 2,
    REPORTE_EXCEL_GENERAL = 3,
    REPORTE_EXCEL_DETALLE = 4
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/modelo/TipoReporteGlosa.ts